import React, {
  FC, useEffect, useState, useMemo, 
} from 'react';
import { useSelector } from 'react-redux';
import { Button, Icon, Input, Select, Tooltip } from '@scuf/common';
import { PropertiesPlugin } from '@hcecbp/webappanalytics';
import { validate } from 'src/utils/validationUtil';
import {
  editModelList,
  getEditModelList,
  getModelEditLoading,
  updateModelQuestions,
} from 'src/slices/contextSlice';
import { useAppDispatch } from 'src/store';
import { toast } from 'react-toastify';
import { Snackbar } from 'src/components/Snackbar/Snackbar';

const validationObj = {
  value: null,
  error: true,
  validation: [['required', { message: 'This field is required' }]],
};

type ValidationObjProps<T> = Omit<typeof validationObj, 'value'> & {
  errorMessage?: string;
  value: T;
};

// type QuestionDataProps = {
//   question_id?: number;
//   question_name: ValidationObjProps<string>;
//   question_options: ValidationObjProps<string>[];
//   preferrable_ans: ValidationObjProps<string> & { isShow: boolean };
//   is_new: boolean;
// };

type QuestionDataProps = {
  question_id?: number;
  question_name: string;
  question_options: string[];
  question_type: string;
  preferrable_ans: string;
  is_new: boolean;
};


type ModelDataPropsNew = {
  is_valid: boolean,
  stage_id: number;
  stage_name: string;
  tableau_link: string;
  questions: QuestionDataProps[];
  user_details?: any;
};

export const StageWithQuestions: FC<{ header: string, modelData: any, stageData: any, refreshEditScreen: Function,handleClose: Function }> = ({ header, modelData, stageData, refreshEditScreen,handleClose }) => {
  const dispatch = useAppDispatch();

  const [modalDataValue, setModalDataValue] = useState<Partial<ModelDataPropsNew>>({});
  const editLoading = useSelector(getModelEditLoading);

  let modalHightLevelData = modelData[0];

  const questionData = stageData.questions;
  const showDelete = true;

  useEffect(() => {
    const questions = stageData.questions
    if(questions !== null){
      questions?.map((question:QuestionDataProps) => ({
          // ...stageData,
          question_id: question.question_id!==null? question.question_id : 0,
          is_new: question.question_id===null? true : false,
          question_name: question.question_name? question.question_name : '',
          type: question.question_type? question.question_type : '',
          question_options: question.question_type==='options'? (question.question_options ?? Array(1).fill('')).map(
            (optionValue:string) => optionValue.length>0? optionValue : '') : []
      }))    
      
      setModalDataValue({
        ...stageData,
        // questions: changePreferrableAns(questions)
      })
    }
    else{
      setModalDataValue({
        ...stageData,
        questions : []
      })
    }}, []);
    

  const disableButton = useMemo(
    () =>
      [
        modalDataValue?.tableau_link ?? '',
        [
          ...(modalDataValue?.questions ?? [])
            .map((questionData) => [
              ...(questionData?.question_options ?? []),
              questionData?.question_name ?? {},
              // questionData?.preferrable_ans ?? {},
            ])
            .flat(),
        ]
      ]
        .flat()
        .some((data) => [null, '', undefined].includes(data.toString())),
        // .some(data => console.log(data)),
    [modalDataValue]
  );


  const onUpdate = async () => {
    if (disableButton) return;
    const questions = modalDataValue?.questions?.map(
      (questionData: QuestionDataProps) => ({
        question_id: questionData?.question_id ?? 0, //if the entry is new, no need to add question id.
        question: questionData?.question_name,
        question_options: questionData?.question_options,
        question_type: questionData?.question_options.length===0? 'input' : 'options',
        preferrable_ans: '',
        is_new: questionData?.is_new ?? false,
      })
    );
    const postData = {
      model_id: modelData[0].model_id,
      stage_id: modalDataValue?.stage_id,
      module_id: modelData[0].module_id,
      questions,
      tableau_link: modalDataValue?.tableau_link,
    };


    const response = await dispatch(updateModelQuestions(postData));
    if (response.meta.requestStatus === 'fulfilled') {
      toast(<Snackbar toastMessage={"Labelling details updated successfully"} />, {
              position: 'bottom-right',
              className: 'fi-toast--snackbar',
              bodyClassName: 'fi-toast__body--snackbar',
              closeOnClick: true,
    });
    refreshEditScreen();
    } else {
      toast.error(
        <Snackbar toastMessage={'Something went wrong, please try again!'} />,
        {
          position: 'top-right',
          className: 'fi-toast--snackbar',
          bodyClassName: 'fi-toast__body--snackbar',
          closeOnClick: true,
        }
      );
    }
  };


  const changePreferrableAns = (question: QuestionDataProps[]) => {
    const modifiedObj = (data: QuestionDataProps, value: boolean) => ({
      ...data,      
      // preferrable_ans: {
      //   value: 
      //     (data.preferrable_ans.value!== null && data.preferrable_ans.value!== undefined)? data.preferrable_ans.value : data.preferrable_ans,
      //   isShow: value
      // }
    });
    if (question.length === 1) {
      return question.map((data: QuestionDataProps) =>
        modifiedObj(data, false)
      );
    } else if (question.length > 1) {
      return question.map((data: QuestionDataProps, i: number) =>
        i + 1 === question.length
          ? modifiedObj(data, false)
          : modifiedObj(data, true)
      );
    } else {
      return question;
    }
  };

  const checkvalidation = (data: any) => {
    let valid:boolean = true;
    if(data.length>0){
      for(var i=data.length-1; i<data.length; i++){
        if(data[i].question_name===null || data[i].question_name===''){
          valid = false
        }
        else{
          valid = true
        }
        if(data[i].question_options.length>0){
          for(var j=0; j<data[i].question_options.length; j++)
          if(data[i].question_options[j].length<=1){
              valid = false 
          }
          else{
            valid = true
          }
        }  
      }
    }
    return valid
  }

  const onAddNewClick = () => {
    const is_valid = checkvalidation(modalDataValue.questions)
    if(is_valid === false){
      setModalDataValue((prevState: any) => ({        
        ...prevState,
        is_valid: is_valid
      }))     
    }
      else{
        setModalDataValue((prevState: any) => {
          const prevQuestionArr =
            prevState?.questions?.map((prevObj: QuestionDataProps) => ({
              ...prevObj,
              question_name: prevObj?.question_name,        
              question_options:
                prevObj?.question_options?.map((optionObj) =>
                  // validate(optionObj, optionObj?.value ?? '')
                  optionObj
                ) ?? []
              // preferrable_ans: prevObj?.preferrable_ans ?? {}
            })) ?? [];
          const questions = [
            ...prevQuestionArr,
            {
            //   preferrable_ans: {
            //     isShow: true,
            //     value: '',
            // },        
              question_name: '',
              question_options: Array(1).fill(''),
              is_new: true,
            },
          ];
          return {
            ...prevState,
            questions: changePreferrableAns(questions),
          };
        });
      }
  };

  const onDeleteClick = (index: number) => {
    setModalDataValue((prevState: any) => {
      const question =
        prevState?.questions?.filter(
          (_: QuestionDataProps, i: number) => i !== index
        ) ?? [];
      return {
        ...prevState,
        questions: changePreferrableAns(question),
      };
    });
  };


  const onTableauChange = (tableau_link: string) => {
    setModalDataValue((prevState) => ({
      ...prevState,
      tableau_link: tableau_link,
    }));
  };



  const onInputChange = (
    field: 'preferrable_ans' | 'question_name',
    value: string,
    index: number
  ) => {    
    const questions = modalDataValue.questions
    questions?.map((data: QuestionDataProps, i:number) => {
      if(i === index && field === 'preferrable_ans') {
        // data.preferrable_ans.value = value
        // data.preferrable_ans.isShow = true
      }
      else if(i === index && field === 'question_name') {
        data.question_name = value
      }
    })  
    setModalDataValue((prevState) => ({
      ...prevState,
      questions: questions
    }))
  };

  const onOptionChange = (
    value: string,
    index: number,
    optionIndex: number
  ) => {
    const updateOption = (data: QuestionDataProps) => ({
      ...data,
      question_options:
        data?.question_options?.map((optionValue, optionI: number) =>
          optionI === optionIndex ?
            //  validate(optionValue, value) 
            value
            : optionValue
        ) ?? ''
    });

    setModalDataValue((prevState) => ({
      ...prevState,
      questions:
        prevState?.questions?.map((data: any, i: number) =>
          i === index ? updateOption(data) : data
        ) ?? [],
    }))
  };

  const onDeleteOption = (index: number, optionIndex: number) => {
    setModalDataValue((prevState) => {
      const updatedQuestions = prevState?.questions?.map((data: any, i: number) => {
        if(i === index){
          const updatedOptions = [...data.question_options]
          updatedOptions.splice(optionIndex,1)
          return{
            ...data,
            question_options: updatedOptions
          }
        }
        return data        
      }) ?? []
      return{
        ...prevState,
        questions: updatedQuestions
      }
    })
  }
  
  const onAddOption = (index: number) => {
    setModalDataValue((prevState) => {
      const updatedQuestions = prevState?.questions?.map((data: any, i:number) =>{
        if(i === index){
          const updatedQuestions = [...data.question_options]
          updatedQuestions.push('')
          return{
            ...data,
            question_options: updatedQuestions
          }
        }
        return data
      }) ?? []
      return{
        ...prevState,
        questions: updatedQuestions
      }
    })
  }

  const getPreferredOptions = (optionSimpleArray: any) => {
    let optionArray: any = [];
    optionSimpleArray.forEach((element: any, index: any) => {
      let obj: any = {};
      obj['value'] = element;
      obj['text'] = element;
      optionArray.push(obj);
    });
    return optionArray;
  }

  return (
    <div className='right-container'>
      <div className='right-container-step-one'>
        <>
          {/* <div className=''> */}
            <div className='content-container'>
              <div className='input-container'>
                <Input
                  className='custom-input'
                  label='Model name'
                  placeholder='Model name'
                  value={modalHightLevelData?.model_name ?? ''}
                  fluid
                  disabled
                />
                <Input
                  className='custom-input'
                  label='Stage'
                  placeholder='Stage'
                  value={modalDataValue?.stage_name ?? ''}
                  fluid
                  disabled
                />
              </div>

              {modalDataValue && <Input
                className='custom-input'
                label='Tableau link'
                placeholder='Tableau link'
                value={modalDataValue?.tableau_link ?? ''}
                error={modalDataValue?.tableau_link === ''? 'This field is required' : ''}
                onChange={(value) => onTableauChange(value)}
                fluid
              />
              }
              <div className='question-container'>
                <div className='question-heading'>
                  <div>Questions</div>
                    <Button
                      className='custom-btn'
                      size='small'
                      textTransform={false}
                      content='Add New Question'
                      // disabled={modalDataValue.is_valid===false? true : false}
                      onClick={() => onAddNewClick()}
                    />
                  </div>

                {modalDataValue && !(JSON.stringify(modalDataValue) === '{}') && modalDataValue.questions && modalDataValue.questions.map(
                  (questionItem: any, i: number) => (
                    <div className='question-set' key={i}>
                      <div className='question-set-heading'>
                        <div>Question #{i + 1}</div>
                        {showDelete && questionItem.is_new && (
                          <Button
                            className='context-delete-btn custom-btn'
                            icon='delete'
                            size='small'
                            textTransform={false}
                            onClick={() => onDeleteClick(i)}
                            content=''
                          />
                        )}
                      </div>
                      <Input
                        className='custom-input'
                        placeholder={`Question #${i + 1}`}
                        value={questionItem?.question_name ?? ''}
                        error={questionItem?.question_name===''? 'This field is required' : ''}
                        onChange={(value) =>
                          onInputChange('question_name', value, i)
                        }
                        fluid
                      />

                      <div className='optional-label'>
                        <label className='label-name'>Options (Optional)</label>                      
                        <Tooltip content={'If the user doesn\'t provide options (Yes, No, Maybe), by default, it will be considered as textbox, which accepts user input'} 
                          position='right center' event='hover' element={<Icon root='global' name='badge-info' size='medium' />}
                          hoverable={true} />
                      </div>                     

                      <div className='question-options'>
                        {questionItem?.question_options?.map(
                          (optionItem: any, optionIndex: any) => (
                            <>
                            <div className='option-container' key={optionIndex + i}>
                              <Input                                
                                className='custom-input'
                                placeholder={`Option #${optionIndex + 1}`}
                                value={optionItem !== null && optionItem !== undefined ? optionItem : ''}
                                fluid
                                error = {optionItem !== null && optionItem !== undefined && optionItem.length<=1 ? 'This field is required' : ''}
                                onChange={(value) =>
                                  onOptionChange(value, i, optionIndex)
                                }
                              />
                              {/* {optionIndex!==0 && */}
                                <Button
                                  className='context-delete-btn-options'
                                  icon='delete'
                                  size='small'
                                  textTransform={false}
                                  onClick={() => onDeleteOption(i, optionIndex)}
                                  content=''
                                />
                              {/* }                               */}
                            </div>
                            </>
                          )
                        )}
                          <Button
                            className='add-field-btn custom-btn'                                
                            size='small'
                            textTransform={false}
                            onClick={() => onAddOption(i)}
                            content='Add Option'
                            icon='badge-plus'
                            disabled={questionItem?.question_options?.length >= 10}
                          />
                      </div>
                      {/* {questionItem?.preferrable_ans?.isShow && 
                        <div className='preferred-answer'>                        
                          <div>Preferred answer</div>
                          <div>
                            <Select
                              placeholder='Preferred answer'
                              className='preferred-select custom-select'
                              // options={getOptions(
                              //   questionItem?.question_options ?? []
                              // )}
                              options={getPreferredOptions(questionItem?.question_options)}
                              onChange={(value: any) =>
                                onInputChange('preferrable_ans', value, i)
                              }
                              error={
                                questionItem?.preferrable_ans.value===''? 'This field is required' : ''
                              }
                              value={questionItem?.preferrable_ans?.value}
                              fluid
                            />
                          </div>                        
                        </div>
                      } */}
                    </div>
                  )
                )}
              </div>
            </div>
            <div className='stage-three-footer'>              
              <Button
                className='action-btn custom-btn'
                size='small'
                type='secondary'
                textTransform={false}
                content='Cancel'
              onClick={() => handleClose()}
              />
              <Button
                className='action-btn custom-btn'
                size='small'
                textTransform={false}
                disabled={disableButton || editLoading}
                loading={editLoading}
                onClick={() => onUpdate()}
                content='Update'
              />
            </div>
        </>
      </div>
    </div>
  );
};

export default StageWithQuestions;